import { FundPriceSetsService_fundPriceSetsServiceGetFundPriceCollection } from '@festina/unitlink-general-types/unitlink/hooks/FundPriceSetsService_fundPriceSetsServiceGetFundPriceCollection'

export const useFetchFundPrices =
  FundPriceSetsService_fundPriceSetsServiceGetFundPriceCollection.useSuspenseQuery
